export default __webpack_public_path__ + "static/media/menu.95ab3ea5.svg";